import { FC } from 'react';

import * as Styles from '../../styles/pages/payment';

type PaymentSuccessFooterProps = {
  onSeeMoreEvents: () => void;
  onViewMyTickets: () => void;
  seeMoreEventsLabel: string;
  myTicketsLabel: string;
};

/**
 * Footer component shown after successful payment
 * Provides navigation to view more events or access purchased tickets
 *
 * Extracted from payment.tsx for reusability and separation of concerns
 * Uses same styles as payment.tsx (CustomBigButton/CustomBigButtonOutlined)
 */
const PaymentSuccessFooter: FC<PaymentSuccessFooterProps> = ({
  onSeeMoreEvents,
  onViewMyTickets,
  seeMoreEventsLabel,
  myTicketsLabel,
}) => {
  return (
    <Styles.PaymentFooter id="payment-success-footer">
      <Styles.CustomBigButtonOutlined
        onClick={onSeeMoreEvents}
        id="see-more-events-button"
        type="button"
      >
        {seeMoreEventsLabel}
      </Styles.CustomBigButtonOutlined>
      <Styles.CustomBigButton
        onClick={onViewMyTickets}
        id="view-my-tickets-button"
        type="button"
      >
        {myTicketsLabel}
      </Styles.CustomBigButton>
    </Styles.PaymentFooter>
  );
};

export default PaymentSuccessFooter;
